var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useReducer, useEffect } from 'react';
import { ApiClient } from '../../api/apiClient';
import { useManualLookup } from '../../hooks/vehicle/useManualLookup';
import { useFetchData } from '../../hooks/useFetchData';
import { trackManualVehicleSelection } from '../../utils/analytics';
var initialFormState = {
    manufacturer: '',
    year: '',
    model: '',
    series: '',
    rego: '',
    state: ''
};
var formReducer = function (state, action) {
    switch (action.type) {
        case 'SET_MANUFACTURER':
            return __assign(__assign({}, state), { manufacturer: action.value, year: '', model: '', series: '' });
        case 'SET_YEAR':
            return __assign(__assign({}, state), { year: action.value, model: '', series: '' });
        case 'SET_MODEL':
            return __assign(__assign({}, state), { model: action.value, series: '' });
        case 'SET_SERIES':
            return __assign(__assign({}, state), { series: action.value });
        case 'SET_REGO':
            return __assign(__assign({}, state), { rego: action.value });
        case 'SET_STATE':
            return __assign(__assign({}, state), { state: action.value });
        case 'LOAD_SAVED_DATA':
            return __assign(__assign({}, state), action.data);
        default:
            return state;
    }
};
// Utility functions for sorting data
var sortManufacturers = function (manufacturers) {
    return manufacturers ? __spreadArray([], manufacturers, true).sort(function (a, b) { return a.Name.localeCompare(b.Name); }) : [];
};
var sortYears = function (years) {
    if (!years)
        return [];
    return years
        .map(function (year) {
        var yearValue = typeof year === 'string' ? year : year.Year;
        return /^\d{4}$/.test(yearValue) ? { Year: yearValue } : null;
    })
        .filter(function (year) { return year !== null && typeof year.Year === 'string'; })
        .sort(function (a, b) { return parseInt(b.Year) - parseInt(a.Year); });
};
var sortByName = function (items) {
    return items ? __spreadArray([], items, true).sort(function (a, b) { return a.Name.localeCompare(b.Name); }) : [];
};
// Reusable dropdown component
var VehicleDropdown = function (_a) {
    var _b, _c, _d;
    var name = _a.name, value = _a.value, onChange = _a.onChange, options = _a.options, isLoading = _a.isLoading, disabled = _a.disabled, placeholder = _a.placeholder, getOptionLabel = _a.getOptionLabel, getOptionValue = _a.getOptionValue;
    return (_jsxs("select", { name: name, id: name, required: true, value: value, onChange: onChange, disabled: disabled || isLoading, children: [_jsx("option", { value: "", children: isLoading
                    ? "Loading ".concat(name, "...")
                    : (((_d = (_c = (_b = window.tiofSettings) === null || _b === void 0 ? void 0 : _b.i18n) === null || _c === void 0 ? void 0 : _c.manualLookup) === null || _d === void 0 ? void 0 : _d["select".concat(name.charAt(0).toUpperCase() + name.slice(1))]) || placeholder) }, "".concat(name, "-placeholder")), Array.isArray(options) && options
                .filter(function (option) {
                // Ensure the option exists and has valid values
                if (!option)
                    return false;
                var value = getOptionValue(option);
                var label = getOptionLabel(option);
                return value !== undefined && value !== null && value !== '' &&
                    label !== undefined && label !== null && label !== '';
            })
                .map(function (option, index) {
                var optionValue = getOptionValue(option);
                var optionLabel = getOptionLabel(option);
                var key = "".concat(name, "-").concat(optionValue, "-").concat(index);
                return (_jsx("option", { value: optionValue, children: optionLabel }, key));
            })] }));
};
// Main component
export var ManualLookup = function (_a) {
    var _b, _c, _d, _e, _f;
    var onRegoLookup = _a.onRegoLookup, onVehiclesFound = _a.onVehiclesFound, initialValues = _a.initialValues, onChange = _a.onChange;
    // Form state with reducer - initialize with initial values
    var _g = useReducer(formReducer, {
        manufacturer: (initialValues === null || initialValues === void 0 ? void 0 : initialValues.manufacturer) || '',
        year: (initialValues === null || initialValues === void 0 ? void 0 : initialValues.year) || '',
        model: (initialValues === null || initialValues === void 0 ? void 0 : initialValues.model) || '',
        series: (initialValues === null || initialValues === void 0 ? void 0 : initialValues.series) || '',
        rego: (initialValues === null || initialValues === void 0 ? void 0 : initialValues.rego) || '',
        state: (initialValues === null || initialValues === void 0 ? void 0 : initialValues.state) || ''
    }), formState = _g[0], dispatch = _g[1];
    var manufacturer = formState.manufacturer, year = formState.year, model = formState.model, series = formState.series, rego = formState.rego, state = formState.state;
    // Form submission state
    var _h = React.useState(null), formError = _h[0], setFormError = _h[1];
    // Use the manual lookup hook
    var _j = useManualLookup(), lookupVehicle = _j.lookupVehicle, isLoading = _j.isLoading, error = _j.error;
    // Update form state when initial values change
    useEffect(function () {
        if (initialValues) {
            dispatch({
                type: 'LOAD_SAVED_DATA',
                data: initialValues
            });
        }
    }, [
        initialValues === null || initialValues === void 0 ? void 0 : initialValues.manufacturer,
        initialValues === null || initialValues === void 0 ? void 0 : initialValues.year,
        initialValues === null || initialValues === void 0 ? void 0 : initialValues.model,
        initialValues === null || initialValues === void 0 ? void 0 : initialValues.series,
        initialValues === null || initialValues === void 0 ? void 0 : initialValues.rego,
        initialValues === null || initialValues === void 0 ? void 0 : initialValues.state
    ]);
    // Data fetching hooks with named functions
    var manufacturersData = useFetchData(React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, manufacturers;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ApiClient.fetchManufacturers()];
                case 1:
                    response = _a.sent();
                    if (!response.success || !response.data) {
                        return [2 /*return*/, {
                                success: false,
                                data: [],
                                error: response.error || 'Failed to fetch manufacturers'
                            }];
                    }
                    manufacturers = Array.isArray(response.data) ? response.data : [response.data];
                    return [2 /*return*/, {
                            success: true,
                            data: manufacturers,
                            error: undefined
                        }];
            }
        });
    }); }, []), // Empty dependencies since this doesn't depend on any props or state
    [], // No dependencies needed for manufacturers
    'Manufacturers');
    var modelsData = useFetchData(React.useCallback(function (manufacturerId, yearValue) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!manufacturerId || !yearValue) {
                        return [2 /*return*/, {
                                success: true,
                                data: [],
                                error: undefined
                            }];
                    }
                    return [4 /*yield*/, ApiClient.fetchManufacturerModels(manufacturerId, yearValue)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, {
                            success: response.success,
                            data: response.data,
                            error: response.error
                        }];
            }
        });
    }); }, []), // Empty dependencies since this doesn't depend on any props or state
    [manufacturer || '', year || ''], // Always pass strings, empty if not selected
    'Models');
    var seriesData = useFetchData(React.useCallback(function (manufacturerId, yearValue, modelId) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!manufacturerId || !yearValue || !modelId) {
                        return [2 /*return*/, {
                                success: true,
                                data: [],
                                error: undefined
                            }];
                    }
                    return [4 /*yield*/, ApiClient.fetchModelSeries(manufacturerId, yearValue, modelId)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, {
                            success: response.success,
                            data: response.data,
                            error: response.error
                        }];
            }
        });
    }); }, []), // Empty dependencies since this doesn't depend on any props or state
    [manufacturer || '', year || '', model || ''], // Always pass strings, empty if not selected
    'Series');
    // States list (optional rego/state fields)
    var statesData = useFetchData(React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ApiClient.fetchStates()];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, {
                            success: true,
                            data: response,
                            error: undefined
                        }];
                case 2:
                    error_1 = _a.sent();
                    return [2 /*return*/, {
                            success: false,
                            data: [],
                            error: error_1 instanceof Error ? error_1.message : 'Failed to fetch states'
                        }];
                case 3: return [2 /*return*/];
            }
        });
    }); }, []), // Empty dependencies since this doesn't depend on any props or state
    [], // No dependencies needed for states
    'States');
    // Process and sort data
    var manufacturers = React.useMemo(function () {
        return sortManufacturers(manufacturersData.data);
    }, [manufacturersData.data]);
    // Generate years based on selected manufacturer
    var years = React.useMemo(function () {
        // If a manufacturer is selected, generate years from its range
        if (manufacturer && manufacturers.length > 0) {
            var selectedManufacturer = manufacturers.find(function (m) { return m.Id === manufacturer; });
            // Try with string conversion if types don't match
            var foundManufacturer = selectedManufacturer;
            if (!foundManufacturer) {
                foundManufacturer = manufacturers.find(function (m) { return String(m.Id) === String(manufacturer); });
            }
            if (foundManufacturer && foundManufacturer.StartYear && foundManufacturer.LatestYear) {
                var yearRange = [];
                for (var y = foundManufacturer.StartYear; y <= foundManufacturer.LatestYear; y++) {
                    yearRange.push({ Year: y.toString() });
                }
                return sortYears(yearRange);
            }
        }
        // Return empty array if no manufacturer selected or manufacturer not found
        return [];
    }, [manufacturer, manufacturers]);
    var models = React.useMemo(function () {
        return sortByName(modelsData.data);
    }, [modelsData.data]);
    var seriesList = React.useMemo(function () {
        return sortByName(seriesData.data);
    }, [seriesData.data]);
    var states = React.useMemo(function () {
        return (Array.isArray(statesData.data) ? statesData.data : []);
    }, [statesData.data]);
    // Form handlers with onChange callback
    var handleManufacturerChange = function (e) {
        var value = e.target.value;
        dispatch({ type: 'SET_MANUFACTURER', value: value });
        onChange === null || onChange === void 0 ? void 0 : onChange({ manufacturer: value });
    };
    var handleYearChange = function (e) {
        var value = e.target.value;
        dispatch({ type: 'SET_YEAR', value: value });
        onChange === null || onChange === void 0 ? void 0 : onChange({ year: value });
    };
    var handleModelChange = function (e) {
        var value = e.target.value;
        dispatch({ type: 'SET_MODEL', value: value });
        onChange === null || onChange === void 0 ? void 0 : onChange({ model: value });
    };
    var handleSeriesChange = function (e) {
        var value = e.target.value;
        dispatch({ type: 'SET_SERIES', value: value });
        onChange === null || onChange === void 0 ? void 0 : onChange({ series: value });
    };
    var handleRegoChange = function (e) {
        var value = e.target.value;
        dispatch({ type: 'SET_REGO', value: value });
        onChange === null || onChange === void 0 ? void 0 : onChange({ rego: value });
    };
    var handleStateChange = function (e) {
        var value = e.target.value;
        dispatch({ type: 'SET_STATE', value: value });
        onChange === null || onChange === void 0 ? void 0 : onChange({ state: value });
    };
    // Handle form submission
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var vehicles, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    // Basic validation
                    if (!manufacturer || !year || !model) {
                        setFormError('Please select manufacturer, year, and model');
                        return [2 /*return*/];
                    }
                    setFormError(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, lookupVehicle({
                            manufacturer: manufacturer,
                            model: model,
                            year: year,
                            series: series,
                            rego: rego,
                            state: state
                        })];
                case 2:
                    vehicles = _a.sent();
                    if (vehicles.length > 0) {
                        // Track successful manual vehicle selection (Step 0.5)
                        trackManualVehicleSelection();
                        onVehiclesFound(vehicles);
                    }
                    else {
                        setFormError('No vehicles found. Please try different selections.');
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    setFormError(err_1 instanceof Error ? err_1.message : 'Failed to lookup vehicle details');
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    // Combined error for display
    var currentError = manufacturersData.error ||
        modelsData.error ||
        seriesData.error ||
        statesData.error ||
        error ||
        formError;
    return (_jsx("div", { className: "vehicle-info-container-manual", children: _jsxs("form", { onSubmit: handleSubmit, className: "max-500", children: [_jsx("div", { className: "form-group full-width", children: _jsx(VehicleDropdown, { name: "make", value: manufacturer, onChange: handleManufacturerChange, options: manufacturers, isLoading: manufacturersData.isLoading, disabled: isLoading, placeholder: "Select Make", getOptionLabel: function (option) { return option.Name; }, getOptionValue: function (option) { return option.Id; } }) }), _jsx("div", { className: "form-group full-width", children: _jsx(VehicleDropdown, { name: "year", value: year, onChange: handleYearChange, options: years, isLoading: false, disabled: !manufacturer || isLoading, placeholder: "Select Year", getOptionLabel: function (option) { return option.Year; }, getOptionValue: function (option) { return option.Year; } }) }), _jsx("div", { className: "form-group full-width", children: _jsx(VehicleDropdown, { name: "model", value: model, onChange: handleModelChange, options: models, isLoading: modelsData.isLoading, disabled: !year || isLoading, placeholder: "Select Model", getOptionLabel: function (option) { return option.Name; }, getOptionValue: function (option) { return option.Id; } }) }), _jsx("div", { className: "form-group full-width", children: _jsx("input", { type: "text", id: "rego", value: rego, onChange: handleRegoChange, placeholder: 'Enter Rego (optional)', "aria-label": 'Enter Rego (optional)' }) }), _jsx("div", { className: "form-group full-width", children: _jsxs("select", { id: "state", value: state, onChange: handleStateChange, disabled: statesData.isLoading, "aria-label": 'Rego State (optional)', children: [_jsx("option", { value: "", children: "Rego State" }), states && states.length > 0 ? (states.map(function (stateOption) { return (_jsx("option", { value: stateOption.StateId, children: stateOption.StateName }, stateOption.StateId)); })) : (_jsx("option", { disabled: true, children: statesData.isLoading ? 'Loading states...' : 'No states available' }))] }) }), _jsx("div", { className: "form-group half-width text-right mb-half-width", children: _jsx("button", { type: "button", className: "button secondary icon-left", onClick: onRegoLookup, disabled: isLoading, children: ((_d = (_c = (_b = window.tiofSettings) === null || _b === void 0 ? void 0 : _b.i18n) === null || _c === void 0 ? void 0 : _c.manualLookup) === null || _d === void 0 ? void 0 : _d.previous) || 'Rego Lookup' }) }), _jsx("div", { className: "form-group half-width mb-half-width", children: _jsx("button", { type: "submit", className: "button", disabled: isLoading, children: isLoading
                            ? 'Saving...'
                            : (((_f = (_e = window.tiofSettings) === null || _e === void 0 ? void 0 : _e.i18n) === null || _f === void 0 ? void 0 : _f.next) || 'Next') }) }), currentError && _jsx("div", { className: "error-message", children: currentError })] }) }));
};
export default ManualLookup;
